import {AppRootStateType} from "../store";

export const selectUserOrders = (state:AppRootStateType) => state.users.orders
export const selectUserEmail = (state:AppRootStateType) => state.users.email